export default {
  auth: [
    {
      path: '/userauth',
      name: 'welcomeuserauth',
      component: require('../pages/welcome/index.vue'),
      meta: {heading: 'welcome userauth'},
    },
  ],
  routes: [
    {
      path: '/user',
      name: 'welcomeuserauth2',
      component: require('../pages/welcome/index.vue'),
      meta: {heading: 'welcome user'},
    },
    {
      path: '/userguest',
      name: 'welcomeuserguest',
      component: require('../pages/welcome/index.vue'),
      meta: {heading: 'welcome userguest'},
      guards: ['guest']
    }
  ],
}

